/*
 * To communicate with mobile app which hosts this app inside webview, ios and android use different methods
 * android exposes direct function calls, while ios only offers passing string messages
*/

type WebviewInterfaceMsgType = 'mapLoaded' | 'displayDocument' | 'downloadDocument' | 'onMapLocationSelected' | 'mapLocationCanceled';

export const WebviewInterface = {
    hasMobileInterface: () => !!(window as any).InfrakitMobileInterfaceIos || !!(window as any).InfrakitMobileInterface,
    hasAndroidInterface: () => !!(window as any).InfrakitMobileInterface,
    hasIosInterface: () => !!(window as any).InfrakitMobileInterfaceIos,

    onMapLoaded: () => call('mapLoaded'),

    displayDocument: (id: number, fullPath: string, name: string) => call('displayDocument', { id, fullPath, name }),

    downloadDocument: (id: number, fullPath: string, name: string) => call('downloadDocument', { id, fullPath, name }),

    onMapLocationSelected: (lat: number, lon: number) => call('onMapLocationSelected', { lat, lon }),

    mapLocationCanceled: () => call('mapLocationCanceled'),
}

const call = (type: WebviewInterfaceMsgType, params?: Record<string, any>) => {
    const ios = (window as any).InfrakitMobileInterfaceIos;
    if (ios) {
        if (typeof ios.postMessage === 'function') {
            ios.postMessage(JSON.stringify({
                type,
                params
            }));
        } else {
            console.warn('ios InfrakitMobileInterface exists but has no postMessage method');
        }
        return;
    }

    const android = (window as any).InfrakitMobileInterface;
    if (android) {
        if (android[type] === 'function') {
            if (['downloadDocument', 'displayDocument'].includes(type)) {
                android[type](params.id, params.fullPath, params.name);
            }
            else if (['onMapLocationSelected'].includes(type)) {
                android[type](params.lat, params.lon);
            }
            else {
                android[type]()
            }
        } else {
            console.warn('android InfrakitMobileInterface exists but has no method', type);
        }
        return;
    }

    console.warn('no InfrakitMobileInterface for ios or android');
}
